import authApi from '@/api/authApi';
import { createErrorHandler, injectToken, removeToken } from '@/api/apiConfig';

export default {
  namespaced: true,

  state: {
    isPending: false,
    token: null,
    expiresIn: null,
    tokenType: 'Bearer',
    refreshTimeOut: null,
    error: '',
    lastTokenTime: null,
  },

  getters: {
    isLoggedIn: (state) => !!state.token,
    isAuthPending: (state) => state.isPending,
    authError: (state) => state.error
  },

  mutations: {
    setAuthPending (state, isPending) {
      state.isPending = isPending;
    },

    setAuthTokenData (state, tokenData) {
      state.token = tokenData.access_token;
      state.expiresIn = tokenData.expires_in;
      state.tokenType = tokenData.token_type;
      state.lastTokenTime = Date.now();
    },

    setAuthError (state, error) {
      state.tokenData = null;
      state.error = error;
    },

    logout (state) {
      state.token = null;
      state.expiresIn = null;
      state.error = '';
    }
  },

  actions: {
    async getToken ({ commit, dispatch }) {
      try {
        commit('setAuthPending', true);

        // Проверяем существующий токен в localStorage
        const tokenData = JSON.parse(localStorage.getItem('zi-token-data'));
        if (tokenData && tokenData.access_token) {
          commit('setAuthTokenData', tokenData);
          injectToken(tokenData.access_token, tokenData.token_type);

          // Запускаем автообновление
          dispatch('scheduleTokenRefresh');
          return tokenData;
        }

        // Запрашиваем новый токен
        const response = await authApi.getToken();
        const { data } = response;

        commit('setAuthTokenData', data);
        injectToken(data.access_token, data.token_type);
        localStorage.setItem('zi-token-data', JSON.stringify(data));

        // Запускаем автообновление
        dispatch('scheduleTokenRefresh');
        return data;
      } catch (error) {
        console.error('Token request failed:', error);
        commit('setAuthError', 'Authentication failed. Please reload the page');
        dispatch('logout');
        throw error;
      } finally {
        commit('setAuthPending', false);
      }
    },

    scheduleTokenRefresh ({ commit, state, dispatch }) {
      // Очищаем предыдущий таймер
      if (state.refreshTimeOut) {
        clearTimeout(state.refreshTimeOut);
      }

      const expiresInMs = state.expiresIn * 1000;
      const refreshTime = expiresInMs - 30000;

      const timer = setTimeout(() => {
        dispatch('refreshTokenSilently');
      }, refreshTime);

      commit('setRefreshTimeout', timer);
    },

    async refreshTokenSilently ({ dispatch }) {
      try {
        console.log('Refreshing token silently...');
        await dispatch('getToken');
      } catch (error) {
        console.error('Silent token refresh failed:', error);
      }
    },

    handleErrors ({ dispatch }) {
      createErrorHandler((error) => {
        if (error.response.status === 401) {
          dispatch('logout');
        }

        return Promise.reject(error);
      });
    },

    logout ({ commit }) {
      commit('logout');
      localStorage.removeItem('zi-token-data');
      removeToken();
    }
  },
};
